import { createContext, PropsWithChildren, useContext } from "react";

export interface CaptchaConfigContextStore {
  captchaSiteKey: string;
}

export const CaptchaConfigContext = createContext<CaptchaConfigContextStore | undefined>(undefined);

export const useCaptchaConfig = () => useContext(CaptchaConfigContext);

/*
 * Provides the captcha configuration to components that need it.
 * Expects server configuration in 'globalThis.serverConfig.login.captchaSiteKey'
 * If a context was already provided it's a noop
 */
export const CaptchaConfigProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const context = useContext(CaptchaConfigContext);
  const captchaSiteKey = globalThis.serverConfig?.login?.captchaSiteKey;

  if (!captchaSiteKey) {
    if (context === undefined) {
      console.warn(
        "CaptchaConfigProvider: no 'serverConfig.login.captchaSiteKey' found and no parent context. Context is not set.",
      );
    }
    return <>{children}</>;
  }

  return <CaptchaConfigContext.Provider value={{ captchaSiteKey }}>{children}</CaptchaConfigContext.Provider>;
};
